<div class="container-fluid mb-3">
    <!-- Close Icon -->
    <div class="text-end color_grey pt-3 pe-2">
        <mat-icon mat-dialog-close class="close-icon">close</mat-icon>
    </div>
    <!-- image -->
    <div mat-dialog-title class="text-center">
        <img class="img-fluid" src="../assets/img/registrations-closed.png">
        <h1 class="mt-3 mb-0">Registrations Closed for 2024-25</h1>
    </div>
    <!-- Body  -->
    <div mat-dialog-content class="text-center">
        <h2>Registrations for HubbleHox ScolarQuest Examination 2024-25 have closed.
            <br>
            Stay tuned! Registrations for the 2025-26 Examination will begin soon.
        </h2>
        <button mat-dialog-close class="btn-cancel mt-2">
            Close
        </button>
    </div>
</div>